export function Brand() {
  return (
    <div className="brand">
      <span className="brand-icon-wrap">
        <img src="/brand/startracker-telescope.png" alt="" />
      </span>
      <strong className="brand-wordmark">StarTracker</strong>
    </div>
  )
}
